<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formAccountingInterface">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button *ngIf="visibleExportCxc" [title]="'Exportar CxC'" [severity]="'contrast'"
                [icon]="'pi pi-file-export'" (onClick)="exportCxC()"></app-custom-button>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteAccountingInterface()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewAccountingInterface()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="accountingInterfaceContract.userNameCreate"
                [createDate]="accountingInterfaceContract.createDate"
                [userNameUpdate]="accountingInterfaceContract.userNameUpdate"
                [updateDate]="accountingInterfaceContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row mt-1 d-flex justify-content-between">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 pe-md-2">
              <div class="row">
                <div class="col-lg-2 col-md-4 col-sm-5 col-6">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-5 col-6">
                  <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                    [required]="true" [recovery]="true"
                    (onChangeSelect)="getEnterprise($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-2 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-4 col-6">
                  <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo Doc. Comercial'"
                    [list]="listBussinessDocumentsTypes" [required]="true"></app-custom-select>
                </div>
                <div class="col-lg-1 col-md-4 col-sm-4 col-6">
                  <app-custom-datepicker formControlName="dateInterface" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-4 col-6">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [autoResize]="false" [maxLength]="50"></app-custom-textarea>
                </div>
                <div class="col-lg-1 col-md-2 col-sm-3 col-6 d-flex align-items-end gap-2">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>
                </div>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
                  <app-custom-button [disabled]="disabledForm" [label]="'Guardar'" [severity]="'primary'"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-accounting-interface-detail [accountingInterfaceModel]="accountingInterfaceContract"
      [typeInterface]="typeInterface" [visiblePreview]="!visibleExportCxc" [permissionUpdatable]="permissionUpdatable"
      [disabledActions]="disabledActions" [siesaSynchronization]="siesaSynchronization"
      (emitQuantityDetails)="quantityDetails = $event"></app-accounting-interface-detail>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>
    No se permite tener dos ventanas/pestañas de {{ nameWindow }} abiertas.
  </h6>
</div>